import { inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NotificationService } from '../../core/notifications/notification.service';
import { environment } from '../../../environments/environment';
import { interval } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UpdateService {
    private updateServiceWorker = inject(SwUpdate);

    private notification = inject(NotificationService);
    constructor() {
        const updateServiceWorker = this.updateServiceWorker;

        if (updateServiceWorker.isEnabled) {
            interval(environment.checkForUpdatesInterval ?? 0).subscribe(() => {
                this.checkForUpdates();
            });
        }
    }

    public async checkForUpdates() {
        if (this.updateServiceWorker.isEnabled) {
            try {
                const updateFound = await this.updateServiceWorker.checkForUpdate();
                console.info(updateFound ? 'Une nouvelle version est disponible.' : 'Actuellement sur la dernière version.');
                if (updateFound) {
                    this.notifyUpdateAvailable();
                }
            } catch (error) {
                console.error('Erreur lors de la vérification de la version:', error);
            }
        }
    }

    private notifyUpdateAvailable(): void {
        this.notification.info(`Une nouvelle version de l'application est disponible, veuillez rafraîchir la page avec la touche F5.`);
    }
}
